import { serializable, alias, object, list, primitive } from 'serializr';

export class NewProduct {
  @serializable(alias('id', primitive()))
  commodityId?: number;

  @serializable(alias('name', primitive()))
  name?: string;

  @serializable(alias('brand_id', primitive()))
  brandId?: number;

  @serializable(alias('b2c', primitive()))
  b2c?: number;

  @serializable(alias('brand_name', primitive()))
  brandName?: number;

  @serializable(alias('net_weight', primitive()))
  netWeight?: number;

  @serializable(alias('net_weight_unit', primitive()))
  netWeightUnit?: string;

  @serializable(alias('gross_weight', primitive()))
  grossWeight?: number;

  @serializable(alias('temperature_control', primitive()))
  temperatureControl?: string;

  @serializable(alias('density', primitive()))
  density?: number;

  @serializable(alias('processing_facility_id', primitive()))
  processingFacilityId?: number;

  @serializable(alias('reporting_period_units', primitive()))
  reportingPeriodUnits?: number;

  @serializable(alias('reporting_period', primitive()))
  reportingPeriod?: string;

  @serializable(alias('processing_facility_cost_percentage', primitive()))
  processingFacilityCostPercentage?: number;

  @serializable(alias('processing_facility_name', primitive()))
  processingFacilityName?: string;

  @serializable(alias('status', primitive()))
  status?: string;

  @serializable(alias('stage', primitive()))
  stage?: number;

  @serializable(alias('emission', primitive()))
  emission?: number;

  @serializable(alias('createdAt', primitive()))
  createdAt?: string;

  @serializable(alias('updatedAt', primitive()))
  updatedAt?: string;

  @serializable(alias('image', primitive()))
  image?: string;

  @serializable(alias('reject_reason', primitive()))
  rejectReason?: string;
}
